<template>
  <power-bi
    code="eyJrIjoiNjViNmU1YzktNmUxZC00OWE3LWE0NzktNmRiOGJmNjRhMjViIiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9"
  />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
  components: {
    PowerBi,
  },
};
</script>
